var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Object3D',{attrs:{"obj":_vm.listener,"position":_vm.position}})
}
var staticRenderFns = []

export { render, staticRenderFns }